module.exports = __webpack_public_path__ + "assets/a0c2afb06b20e7ef27e64cb269c14a2b.mp3";